/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Gpminimumticketsize4Inputs */

const en_coinvestments_tracking_gpminimumticketsize4 = /** @type {(inputs: Coinvestments_Tracking_Gpminimumticketsize4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Min. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Est. Min. Ticket Size" |
*
* @param {Coinvestments_Tracking_Gpminimumticketsize4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_gpminimumticketsize4 = /** @type {((inputs?: Coinvestments_Tracking_Gpminimumticketsize4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Gpminimumticketsize4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_gpminimumticketsize4(inputs)
});
export { coinvestments_tracking_gpminimumticketsize4 as "coInvestments_tracking_gpMinimumTicketSize" }